import { TenantContext } from '@/components';
import { usersRepo } from '@/constants/providers';
import { QueryOptions } from '@/modules/types';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { Role } from '../domain/role';
import { UserKey } from './types';

export const useGetUserRoles = (options?: QueryOptions<Role[]>) => {
  const { currentSelectedTenant } = useContext(TenantContext);
  return useQuery<Role[]>(
    [...UserKey.Roles, currentSelectedTenant?.id],
    () => usersRepo.getUserRoles(),
    {
      ...options,
    },
  );
};
